import { HTMLAttributes, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { RosterFunction } from 'components/types';

import { getRosterFunctions } from 'RestAPIs/roster/functions';

import { AutocompleteRenderOptionState } from '@mui/material/Autocomplete';

import { MuiAutocompleteOption } from 'components/shared';

const useRosterFunctions = () => {
  const { t } = useTranslation('common');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [rosterFunctions, setRosterFunctions] = useState<RosterFunction[]>([]);

  const getOptionLabel = (option: RosterFunction | string) => {
    if (typeof option === 'string') {
      return option;
    }

    const description = option?.description ?? '';

    return option?.eFlags?.includes('CAPPLAN_EXCLUDE')
      ? `${description} ${t('excluded').toLowerCase()}`
      : description;
  };

  const renderOption = (
    props: Omit<HTMLAttributes<HTMLLIElement>, 'children'>,
    option: RosterFunction,
    state: AutocompleteRenderOptionState
  ) => (
    <MuiAutocompleteOption
      {...props}
      key={`option_${option.id}`}
      inputValue={state.inputValue}
      selected={state.selected}
      label={getOptionLabel(option)}
    />
  );

  const isOptionDisabled = (option: RosterFunction) =>
    option.eFlags.includes('CAPPLAN_EXCLUDE');

  useEffect(() => {
    if (!rosterFunctions.length) {
      setIsLoading(true);
      getRosterFunctions()
        .then(({ data }) => {
          setRosterFunctions(data);
          setIsLoading(false);
        })
        .catch(() => {
          setIsLoading(false);
        });
    }
  }, []);

  return {
    rosterFunctions,
    isLoading,
    renderOption,
    getOptionLabel,
    isOptionDisabled
  };
};

export default useRosterFunctions;
